<template>
  <div v-for="(banner, index) in banners" :key="index"
    class="flex flex-row w-full gap-4 justify-center border-x-0 text-sm cursor-pointer" :class="borderClass"
    @click="handleBannerClick(banner, index)">
    <div class="text-black flex justify-between items-center">
      <img :src="banner.content?.source" @error="onImageError" class="object-contain max-w-full block"
        alt="Banner Image" title="Banner Image"/>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: Object,
  config: Object,
});

const banners = computed(() => props.items?.banners || []);
const header = computed(() => props.items?.header);
const borderClass = computed(() =>
  props.config?.border ? "ring-2 ring-stone-200" : ""
);

function onImageError(event) {
  event.target.src = "https://ns-static-cdn.nstore.in/mall4all/1746607169309";
}

async function handleBannerClick(banner, index) {
  await useBannerAction(banner, header.value, index, 'strip_image');
}
</script>

<style>
.image-height {
  height: 80px;
}
</style>
